export default {
      id: "event_log-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#event_log",
      toString: function () {
        return this.url;
      }
    }